import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SettingsPage from '../../pages/settings/SettingsPage';
import DashboardPage from '../../pages/dashboard/DashboardPage';
import Layout from '../../components/layout';
import LoginPage from '../../pages/login/LoginPage';
import { useAuth } from 'contexts/AuthContext';
import InTransitShipmentsPage from '../../pages/shipments/in-transit/InTransitShipmentsPage';
import DeliveredShipmentsPage from '../../pages/shipments/delivered/DeliveredShipmentsPage';
import LocalShipmentsPage from '../../pages/shipments/local/LocalShipmentsPage';
import DMVShipmentsPage from '../../pages/shipments/dmv/DMVShipmentsPage';
import TrackingPage from '../../pages/shipments/in-transit/TrackingPage';
import ActivityLogPage  from '../../pages/activity-log/ActivityLogPage';
import CnAnalysisPage from '../../pages/reports/CnAnalysisPage';
import SimConsentReportPage from '../../pages/reports/SimConsentReportPage';
import VehicleDetailsPage from 'pages/shipments/in-transit/VehicleDetailsPage';
import InStockShipmentsPage from 'pages/shipments/in-stock/InStockShipmentsPage';

function FullScreenSpinner() {
  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
    </div>
  );
}

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, authLoading } = useAuth();
  if (authLoading) return <FullScreenSpinner />;
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, authLoading } = useAuth();
  if (authLoading) return null;
  return !isAuthenticated ? <>{children}</> : <Navigate to="/dashboard" replace />;
};

const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/" element={<Navigate to="/shipments/in-transit" replace />} />
      <Route path="/dashboard" element={<ProtectedRoute><Layout><DashboardPage /></Layout></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Layout><SettingsPage /></Layout></ProtectedRoute>} />
      <Route path="/shipments/in-transit" element={<ProtectedRoute><Layout><InTransitShipmentsPage /></Layout></ProtectedRoute>} />
      <Route path="/shipments/in-transit/:cnNumber" element={<ProtectedRoute><Layout><TrackingPage /></Layout></ProtectedRoute>} />
      <Route path="/shipments/delivered" element={<ProtectedRoute><Layout><DeliveredShipmentsPage /></Layout></ProtectedRoute>} />
      <Route path="/shipments/local" element={<ProtectedRoute><Layout><LocalShipmentsPage /></Layout></ProtectedRoute>} />
      <Route path="/shipments/dmv" element={<ProtectedRoute><Layout><DMVShipmentsPage /></Layout></ProtectedRoute>} />
      <Route path="/shipments/in-stock" element={<ProtectedRoute><Layout><InStockShipmentsPage /></Layout></ProtectedRoute>} />
      <Route path="/reports" element={<Navigate to="/reports/sim-consent" replace />} />
      <Route path="/reports/activity-log" element={<ProtectedRoute><Layout><ActivityLogPage /></Layout></ProtectedRoute>} />
      <Route path="/reports/cn-analysis" element={<ProtectedRoute><Layout><CnAnalysisPage /></Layout></ProtectedRoute>} />
      <Route path="/reports/sim-consent" element={<ProtectedRoute><Layout><SimConsentReportPage /></Layout></ProtectedRoute>} />
      <Route path="/settings/users" element={<ProtectedRoute><Layout><SettingsPage /></Layout></ProtectedRoute>} />
      <Route path="/reports/vehicle-details" element={<ProtectedRoute><Layout><VehicleDetailsPage /></Layout></ProtectedRoute>} />
    </Routes>
  );
};

export default AppRouter;
